import React, { Component } from "react";
import { loading } from "../components/CustomComponent.js";
export default class PolicyPrivacy extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  async componentDidMount() {
    loading(false);
  }
  async componentDidUpdate() {
  }

  render() {
    return (
      <div className="m-4 px-3 py-5 rounded-4 bg-light shadow mx-auto" style={{maxWidth:700}}>

  <section className="mb-5">
    <h2 className="fw-bold text-center">ข้อกำหนดและเงื่อนไข (Terms & Conditions)</h2>
    <h4 className="fw-bold text-center mb-5">การสั่งสินค้าผ่าน Pre-Order</h4>

    <p>
      ข้อกำหนดนี้ใช้กับการสั่งซื้อสินค้าแบบ Pre-Order และการขนส่งจากต่างประเทศทั้งหมด
      โดยเงื่อนไขนี้ใช้เฉพาะสินค้า Pre-Order เท่านั้น
    </p>

    <ol>
      <li>
        <b>สินค้า Pre-Order</b><br/>
        สินค้าเป็นการสั่งจากต่างประเทศ ไม่มีสต็อกในไทย ต้องชำระเงินเต็มจำนวนก่อนดำเนินการ
      </li>

      <li>
        <b>การยกเลิก / คืนเงิน</b><br/>
        ไม่สามารถยกเลิก แก้ไข หรือคืนเงินได้ทุกกรณี (ยกเว้นบริษัทไม่สามารถจัดหาได้)
      </li>

      <li>
        <b>ราคาและการชำระเงิน</b><br/>
        ราคาสินค้าเป็นสกุลเงินบาท (THB) และไม่รวมค่าขนส่ง ภาษีนำเข้า หรือค่าธรรมเนียมอื่น ๆ
        ลูกค้าต้องรับผิดชอบค่าใช้จ่ายเพิ่มเติมที่ไม่ได้ระบุ
      </li>

      <li>
        <b>ระยะเวลาจัดส่ง</b><br/>
        ระยะเวลาที่แจ้งเป็นเพียงประมาณการ ไม่สามารถการันตีได้ อาจล่าช้าจาก:
        ศุลกากร / ขนส่ง / ผู้ผลิต / เหตุสุดวิสัย
        บริษัทไม่รับผิดชอบความล่าช้าทุกกรณีที่ควบคุมไม่ได้
      </li>

      <li>
        <b>การขนส่งและความเสี่ยง</b><br/>
        จัดส่งผ่านบริษัทขนส่งภายนอก ความเสี่ยงโอนให้ลูกค้าทันทีเมื่อส่งมอบให้ขนส่ง
        บริษัทไม่รับผิดชอบความเสียหายหรือสูญหายระหว่างขนส่ง
      </li>

      <li>
        <b>ภาษีและอากรนำเข้า</b><br/>
        ลูกค้าเป็นผู้รับผิดชอบภาษีและค่าธรรมเนียมทั้งหมด
        บริษัทช่วยดำเนินเอกสาร แต่ไม่รับผิดชอบความล่าช้าจากศุลกากร
      </li>

      <li>
        <b>การคืนสินค้า / เคลม</b><br/>
        ไม่รับคืนหรือเปลี่ยนทุกกรณี ยกเว้น:
        สินค้าผิดหรือชำรุดจากโรงงาน ต้องแจ้งภายใน 30 วัน พร้อมหลักฐาน
        บริษัทขอสงวนสิทธิ์ในการพิจารณา
      </li>

      <li>
        <b>ข้อจำกัดความรับผิด</b><br/>
        บริษัทเป็นตัวกลางในการสั่งซื้อ ไม่รับประกันคุณภาพสินค้า
        ความเสียหายสูงสุดไม่เกินมูลค่าสินค้า
      </li>

      <li>
        <b>เหตุสุดวิสัย</b><br/>
        บริษัทไม่รับผิดชอบต่อเหตุการณ์ที่ควบคุมไม่ได้ เช่น
        ภัยธรรมชาติ นโยบายรัฐ หรือการขนส่ง
      </li>

      <li>
        <b>การเปลี่ยนแปลงเงื่อนไข</b><br/>
        บริษัทสามารถเปลี่ยนแปลงเงื่อนไขได้โดยไม่ต้องแจ้งล่วงหน้า
      </li>
    </ol>
  </section>

  <section>
    <h2 className="fw-bold text-center">Terms & Conditions</h2>
    <h4 className="fw-bold text-center mb-5">Pre-Order Purchases</h4>

    <p>
      These terms apply to all Pre-Order purchases and international shipping.
      This policy is strictly for Pre-Order items only.
    </p>

    <ol>
      <li>
        <b>Pre-Order Products</b><br/>
        All items are sourced from overseas with no local stock.
        Full payment is required before processing.
      </li>

      <li>
        <b>Cancellation / Refund</b><br/>
        Orders cannot be canceled, modified, or refunded under any circumstances
        (except when the company is unable to source the product).
      </li>

      <li>
        <b>Pricing & Payment</b><br/>
        Prices are listed in Thai Baht (THB) and exclude shipping fees,
        import taxes, and other charges. Customers are responsible for additional costs.
      </li>

      <li>
        <b>Delivery Time</b><br/>
        Delivery timelines are estimates only and not guaranteed.
        Delays may occur due to customs, logistics, manufacturers, or unforeseen events.
        The company is not responsible for delays beyond its control.
      </li>

      <li>
        <b>Shipping & Risk</b><br/>
        Shipping is handled by third-party carriers.
        Risk transfers to the customer once the item is handed over to the carrier.
        The company is not responsible for loss or damage during transit.
      </li>

      <li>
        <b>Import Duties & Taxes</b><br/>
        Customers are responsible for all import duties and fees.
        The company may assist with documentation but is not responsible for customs delays.
      </li>

      <li>
        <b>Returns / Claims</b><br/>
        No returns or exchanges are accepted except for incorrect or defective items.
        Claims must be reported within 30 days with valid evidence.
        The company reserves the right to review each case.
      </li>

      <li>
        <b>Limitation of Liability</b><br/>
        The company acts as an intermediary and does not guarantee product quality.
        Liability is limited to the value of the product.
      </li>

      <li>
        <b>Force Majeure</b><br/>
        The company is not liable for events beyond its control,
        including natural disasters, government policies, or logistics issues.
      </li>

      <li>
        <b>Changes to Terms</b><br/>
        The company reserves the right to modify these terms without prior notice.
      </li>
    </ol>
  </section>

</div>
    );
  }
}
